<div  role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">DPA Client</h2>
      </div>
      <div class="modal-body">
        <form #clientForm="ngForm">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                  <div class="col-md-2">
                    <div class="form-group">
                        <label for="clientTitle">Title</label>
                        <select name="clientTitle" id="clientTitle" class="form-control" ngModel required>
                          <option *ngFor="let title of titles" value="{{title.id}}">{{title.name}}</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                        <label for="title">First Name</label>
                        <input class="form-control" name="clientFname" id="clientFname"  placeholder="First Name" ngModel required>
                      </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                        <label for="clientLname">Last Name</label>
                        <input class="form-control" name="clientLname" id="clientLname"  placeholder="Last Name" ngModel required>
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                        <label for="ClientEmail">Email</label>
                        <input class="form-control" name="clientEmail" id="clientEmail"  placeholder="Email" ngModel required>
                      </div>
                  </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                      <label for="clientTelephone">Telephone</label>
                      <input class="form-control" name="clientTelephone" id="clientTelephone"  placeholder="Telephone" ngModel required>
                    </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                      <label for="clientMobile">Mobile</label>
                      <input class="form-control" name="clientMobile" id="clientMobile"  placeholder="Mobile" ngModel required>
                    </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-8">
                  <div class="form-group">
                      <label for="title">Address</label>
                      <input class="form-control" name="address" id="address"  placeholder="Address" ngModel required>
                    </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                      <label for="postcode">Postcode</label>
                      <input class="form-control" name="postcode" id="postcode"  placeholder="Postcode" ngModel required>
                    </div>
                </div>
            </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn btn-success" (click)="saveClient(clientForm.value)" [disabled]="clientForm.invalid">Save Client</button>
          <button type="button" class="btn btn-light" (click)="closeModal()">Close</button>
      </div>
    </div>
  </div>